import classNames from 'classnames';
import _ from 'lodash';
import React from 'react';
import { EventOrValueHandler } from 'redux-form';

import styles from './transparent-input.scss';

interface Props {
  id?: string;
  placeholder?: string;
  autoFocus?: boolean;
  className?: string;
  error?: boolean;
  autoSelect?: boolean;
  onBlur?: EventOrValueHandler<React.FocusEvent<any>>;
  onChange: EventOrValueHandler<React.ChangeEvent<any>>;
  onFocus?: EventOrValueHandler<React.FocusEvent<any>>;
  value: string;
}

class TransparentInput extends React.PureComponent<Props> {
  public inputRef: HTMLInputElement;

  public select(): void {
    if (this.props.autoSelect) {
      this.inputRef && this.inputRef.select();
    }
  }

  public setInputRef(input: HTMLInputElement): void {
    if (this.inputRef) {
      return;
    }

    this.inputRef = input;

    this.select();
  }

  public onFocusHandler(): void {
    const { onFocus } = this.props;

    this.select();
    onFocus && onFocus(undefined);
  }

  public render() {
    const { className, error, ...props } = this.props;
    const inputClassNames = classNames(styles.input, className, {
      [styles.error]: error,
    });

    return (
      <div className={styles.wrapper}>
        <input
          data-hook="transparent-input"
          {..._.omit(props, 'autoSelect')}
          ref={this.setInputRef.bind(this)}
          autoComplete="off"
          className={inputClassNames}
          onFocus={this.onFocusHandler.bind(this)}
        />
      </div>
    );
  }
}

export default TransparentInput;
